import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";

const PublishedSelect = (props) => {
    return (
        <InputGroup>
            <Form.Select value={props.value} onChange={props.onChange}>
                <option value="">ทั้งหมด</option>
                <option value="0">ซ่อนจากสาธารณะ</option>
                <option value="1">เปิดเผยต่อสาธารณะ</option>
            </Form.Select>
        </InputGroup>
    );
};

export default PublishedSelect;
